import { Box } from "@twilio-paste/core/box";
import { Column, Grid } from "@twilio-paste/core/grid";
import React from "react";
import { SlantedBackgroundGradient } from "../../../shared/components/SlantedBackgroundGradient";
import { HOMEPAGE_SECTION_OVERFLOW_OFFSET, SITE_CONTENT_MAX_WIDTH } from "../../../shared/constants";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import { GetStartedInclusive } from "./GetStartedInclusive";
import { GetStartedRunning } from "./GetStartedRunning";
import { GetStarterWhy } from "./GetStartedWhy";

const DELAY_INTERVAL = 250;

export const GetStarted: React.FC = () => {
    const { breakpointIndex } = useWindowSize();

    return (
        <Box paddingX={["space90", "space90", "space180"]} position="relative">
            <SlantedBackgroundGradient
                startColor="colorBackgroundBrandStronger"
                endColor="colorBackgroundBrandStrong"
                styles={{ bottom: `${HOMEPAGE_SECTION_OVERFLOW_OFFSET}px` }}
            >
                <Box
                    maxWidth={SITE_CONTENT_MAX_WIDTH}
                    marginLeft="auto"
                    marginRight="auto"
                    position="relative"
                    zIndex="zIndex10"
                    paddingTop="space200"
                    marginTop="spaceNegative160"
                >
                    <Grid as="section" gutter="space40" vertical={[true, true, false]} equalColumnHeights>
                        <Column span={4}>
                            <GetStarterWhy />
                        </Column>
                        <Column span={4}>
                            <GetStartedInclusive
                                animationDelay={
                                    breakpointIndex === undefined || breakpointIndex > 1 ? DELAY_INTERVAL : 0
                                }
                            />
                        </Column>
                        <Column span={4}>
                            <GetStartedRunning
                                animationDelay={
                                    breakpointIndex === undefined || breakpointIndex > 1 ? DELAY_INTERVAL * 1.5 : 0
                                }
                            />
                        </Column>
                    </Grid>
                </Box>
            </SlantedBackgroundGradient>
        </Box>
    );
};
